
import React from 'react';

const Home = '950a99d07777436d293fd763f07f0f90&units=metric';



export default Home;